
{
  "loading": "加载中...",
  "login": {
    "title": "登录",
    "description": "欢迎回来！请登录您的账户",
    "email": "电子邮件",
    "emailPlaceholder": "输入您的电子邮件",
    "password": "密码",
    "passwordPlaceholder": "输入您的密码",
    "submit": "登录",
    "loginButton": "登录",
    "loggingIn": "登录中...",
    "forgotPassword": "忘记密码？"
  },
  "signup": {
    "title": "注册",
    "description": "创建您的账户以开始使用",
    "firstName": "名字",
    "firstNamePlaceholder": "输入您的名字",
    "lastName": "姓氏",
    "lastNamePlaceholder": "输入您的姓氏",
    "name": "全名",
    "namePlaceholder": "输入您的全名",
    "email": "电子邮件",
    "emailPlaceholder": "输入您的电子邮件",
    "password": "密码",
    "passwordPlaceholder": "输入您的密码",
    "confirmPassword": "确认密码",
    "confirmPasswordPlaceholder": "确认您的密码",
    "submit": "创建账户",
    "signupButton": "创建账户",
    "createAccountButton": "创建账户",
    "signingUp": "创建账户中...",
    "creatingAccount": "创建账户中...",
    "terms": "我同意服务条款和隐私政策"
  },
  "forgotPassword": {
    "title": "重设密码",
    "description": "输入您的电子邮件以接收密码重设链接",
    "email": "电子邮件",
    "emailPlaceholder": "输入您的电子邮件",
    "submit": "发送重设链接",
    "sendResetButton": "发送重设链接",
    "sendingReset": "发送重设链接中...",
    "success": "密码重设链接已发送到您的电子邮件",
    "error": "发送重设链接失败",
    "backToLogin": "返回登录"
  },
  "resetPassword": {
    "title": "设置新密码",
    "description": "输入您的新密码",
    "password": "新密码",
    "passwordPlaceholder": "输入新密码",
    "confirmPassword": "确认新密码",
    "confirmPasswordPlaceholder": "确认新密码",
    "submit": "更新密码",
    "resetButton": "更新密码",
    "resetting": "更新密码中...",
    "success": "密码已成功更新",
    "error": "更新密码失败",
    "updatingPassword": "更新密码中...",
    "updatePasswordButton": "更新密码",
    "backToLogin": "返回登录"
  },
  "socialAuth": {
    "orDivider": "或通过以下方式继续",
    "continueWithGoogle": "使用 Google 继续"
  },
  "validation": {
    "emailRequired": "电子邮件为必填",
    "emailInvalid": "请输入有效的电子邮件地址",
    "passwordRequired": "密码为必填",
    "passwordTooShort": "密码必须至少6个字符",
    "passwordMinLength": "密码必须至少6个字符",
    "passwordsDoNotMatch": "密码不匹配",
    "nameRequired": "姓名为必填",
    "firstNameRequired": "名字为必填",
    "lastNameRequired": "姓氏为必填"
  },
  "languageNote": "请注意：所有列表和通信主要使用英文和繁体中文。"
}
